import React, { useEffect } from "react";
import { UserAddressCard } from "./UserAddressCard";
import { useAppDispatch, useAppSelector } from "./../../../State/Store";
import { fetchAllAddress } from "../../../State/customer/AddressSlice";

export const Address = () => {
  const { addresses, auth } = useAppSelector((store) => store);
  const dispatch = useAppDispatch();
  useEffect(() => {
    dispatch(fetchAllAddress());
  }, []);
  return (
    <div className="space-y-3 px-10">
      <h1 className="text-2xl font-bold text-gray-600">Addresses</h1>
     {addresses?.addresses && addresses.addresses.length > 0 ? (
    addresses.addresses.map((item, index) => (
      <UserAddressCard
        item={item}
        auth={auth?.user?.fullName || ""}
        key={index}
      />
    ))
  ) : (
    <h1 className="text-primary text-center font-semibold text-2xl">Add Address For Delivery Purpose In Cart</h1>
  )}
    </div>
  );
};
